import React from 'react';
import { AccordionButton as AccordionButtonNew } from './AccordionButton';
import { convertOldAccordionButtonProps } from './converter.old';
import type { OldAccordionButtonProps } from './converter.old';

export type AccordionButtonProps = OldAccordionButtonProps;

export const AccordionButton = React.forwardRef<HTMLButtonElement, AccordionButtonProps>((props, ref) => {
  return <AccordionButtonNew {...convertOldAccordionButtonProps(props)} ref={ref} />;
});
